export const GOI_COMPANY_ADDRESS = "서울시 관악구 신림로 132, 1,2,3층";
